import { useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "@/api";
import { useAuth } from "@/auth";
import { useLang } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AkunTab({ user }) {
  const { t } = useLang();
  const { refreshUser } = useAuth();
  const p = user.alumni_profile || {};
  const [form, setForm] = useState({ aktivitas: p.aktivitas || "", email: user.email, wa: p.wa || "" });
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/auth/profile", form);
      await refreshUser();
      toast.success(t("common.saved"));
    } catch (err) { toast.error(fmtErr(err)); }
    setBusy(false);
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="akun-tab">
      <div className="bg-white rounded-xl border border-emerald-900/10 shadow-sm p-8">
        <h3 className="font-display text-2xl font-bold text-emerald-900 mb-6">{user.name}</h3>
        {user.role === "alumni" && (
          <dl className="space-y-3 text-sm">
            <div className="flex justify-between border-b border-slate-100 pb-2"><dt className="text-slate-500">{t("alumni.tingkatan")}</dt><dd className="font-semibold text-emerald-900">{p.tingkatan}</dd></div>
            <div className="flex justify-between border-b border-slate-100 pb-2"><dt className="text-slate-500">{t("alumni.tahun_lulus")}</dt><dd className="font-semibold text-emerald-900">{p.tahun_lulus}</dd></div>
            <div className="flex justify-between gap-4"><dt className="text-slate-500 shrink-0">{t("alumni.domisili")}</dt><dd className="font-medium text-slate-800 text-right">{[p.desa, p.rt && `RT ${p.rt}`, p.rw && `RW ${p.rw}`, p.kecamatan, p.kabupaten, p.provinsi].filter(Boolean).join(", ")}</dd></div>
          </dl>
        )}
      </div>

      <form onSubmit={save} className="bg-white rounded-xl border border-emerald-900/10 shadow-sm p-8 space-y-5" data-testid="akun-form">
        {user.role === "alumni" && (
          <div>
            <Label className="text-sm font-medium text-slate-700">{t("alumni.aktivitas")}</Label>
            <Input value={form.aktivitas} onChange={(e) => setForm({ ...form, aktivitas: e.target.value })} className="mt-1.5" data-testid="akun-aktivitas-input" />
          </div>
        )}
        <div>
          <Label className="text-sm font-medium text-slate-700">Email</Label>
          <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="mt-1.5" data-testid="akun-email-input" />
        </div>
        {user.role === "alumni" && (
          <div>
            <Label className="text-sm font-medium text-slate-700">{t("alumni.wa")}</Label>
            <Input value={form.wa} onChange={(e) => setForm({ ...form, wa: e.target.value })} className="mt-1.5" data-testid="akun-wa-input" />
          </div>
        )}
        <Button type="submit" disabled={busy} className="rounded-full bg-emerald-800 hover:bg-emerald-900" data-testid="akun-save-button">
          {busy ? t("common.loading") : t("common.save")}
        </Button>
      </form>
    </div>
  );
}
